import getCriticalError from './critical-error';
import getNetworkStatus from './network-status';

export default {
  getCriticalError,
  getNetworkStatus,
};
